module.exports = __webpack_public_path__ + "img/gameCheckbox.0acbeefb.png";